// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__Ev0bQ","label":"Category_label__10HMm","content":"Category_content__1PzZX","header":"Category_header__3KBwe","location":"Category_location__1ALUE"};